import { BaseModifier } from "./base-modifier";
export class ImageModifier extends BaseModifier {
    constructor() {
        super(".image:file");
    }
    initialize() {
        const id = `#${this.input.jQueryObject.attr("id")}`;
        const label = this.input.jQueryObject.data("label");
        $.uploadPreview({
            input_field: id,
            preview_box: `${id}-preview`,
            label_field: `${id}-label`,
            label_default: label,
            label_selected: label,
            no_label: false, // Default: false
        });
    }
    prepareValue(formData, name) {
        return new Promise((resolve) => {
            formData.set(name, this.input.jQueryObject[0].files[0]);
            resolve();
        });
    }
}
